import { Box, Stack } from '@mui/material';

export default function StatCard({ statDescription, stat }) {
	return (
		<Stack
			spacing="50px"
			direction="row"
			alignItems="center"
			sx={{
				padding: 2,
				bgcolor: 'white',
				borderRadius: '5px',
				border: '1px solid #0000003B',
			}}
		>
			<Box>{statDescription}</Box>
			<Box>{stat}</Box>
		</Stack>
	);
}
